/** @format */

import Modal from 'react-modal';
Modal.setAppElement('#root');
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		width: '50%',
		background: 'rgba(102, 103, 171, 1)',
		color: '#fff',
		borderRadius: '10px',
		zIndex: '99999999999999999999999',
	},
};
const ModalCustom = ({
	modalIsOpen = false,
	children,
	classes,
	styles,
	onRequestClose,
}) => {
	return (
		<Modal
			isOpen={modalIsOpen}
			className={classes}
			onRequestClose={onRequestClose}
			style={{
				content: { ...customStyles.content, ...(styles?.content || {}) },
				overlay: { ...(styles?.overlay || {}) },
			}}>
			{children}
		</Modal>
	);
};

export default ModalCustom;
